import React, { useEffect }  from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import CandidateBoard from "./components/CandidateBoard";
import { 
    Users,
    UserPlus,
    TrendingUp,
    CheckCircle,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { 
	getJobRoleRequestDetails, 
} from "../../../redux/jobrolerequest/jobRoleRequestState";

const RecruitmentView = ({getRecord, recordData}) => {
    const { overvieId } = useParams();
    
    useEffect(() => {
        getRecord(overvieId);
    }, [getRecord, overvieId]);

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6">
                <SummaryHeader
                    title={recordData?.job_role_title}
                    icon={Users}
                    color={"green"}
                >
                    
                </SummaryHeader>
                <CandidateBoard jobRoleRequestId={overvieId}/>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordData: state.jobRoleRequest.jobRoleRequestDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getJobRoleRequestDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecruitmentView);